// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M29Q","colBig":"styles_colBig__jkODl","colSmall":"styles_colSmall__cIrak"};